import React, { useState } from 'react';
import '../styles/SystemInfo.css';

const SystemInfo: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="system-info-container">
      <div className="system-info-header" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="info-header-content">
          <div className="info-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
          </div>
          <div className="info-title-section">
            <h3>Πώς λειτουργεί το σύστημα</h3>
            <p className="info-subtitle">Μάθετε περισσότερα για την υπηρεσία ελέγχου ασφάλισης</p>
          </div>
        </div>
        <svg 
          className={`expand-icon ${isExpanded ? 'expanded' : ''}`}
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      {isExpanded && (
        <div className="system-info-content">
          <div className="info-section">
            <div className="info-section-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              <h4>Τι κάνει το σύστημα</h4>
            </div>
            <p>
              Το σύστημα ελέγχει αυτόματα την κατάσταση ασφάλισης οχημάτων μέσω του 
              <strong> Ελληνικού Κέντρου Ασφάλισης (HIC - Hellenic Insurance Center)</strong>. 
              Για κάθε όχημα, ελέγχει εάν είναι ασφαλισμένο, ποια ασφαλιστική εταιρία 
              το καλύπτει, και τις ημερομηνίες κάλυψης.
            </p>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                <polyline points="17 6 23 6 23 12"/>
              </svg>
              <h4>Πώς λειτουργεί</h4>
            </div>
            <ol className="info-list">
              <li>
                <strong>Ανέβασμα:</strong> Ανεβάζετε ένα αρχείο Excel με ΑΦΜ και Αριθμό Κυκλοφορίας
              </li>
              <li>
                <strong>Επιλογή:</strong> Επιλέγετε ποια οχήματα θέλετε να ελέγξετε (όλα επιλέγονται αυτόματα)
              </li>
              <li>
                <strong>Επεξεργασία:</strong> Το σύστημα ελέγχει κάθε όχημα μέσω του HIC API
              </li>
              <li>
                <strong>Αποτελέσματα:</strong> Λαμβάνετε πλήρη αναφορά με όλες τις λεπτομέρειες ασφάλισης
              </li>
            </ol>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 6v6l4 2"/>
              </svg>
              <h4>Υπηρεσία που χρησιμοποιείται</h4>
            </div>
            <div className="service-info">
              <div className="service-name">
                <strong>HIC (Hellenic Insurance Center)</strong>
                <span className="service-badge">Επίσημη Υπηρεσία</span>
              </div>
              <p className="service-description">
                Το HIC είναι το επίσημο ελληνικό σύστημα διαχείρισης ασφάλισης οχημάτων. 
                Το σύστημά μας συνδέεται απευθείας με την επίσημη υπηρεσία για να 
                λάβετε ακριβή και ενημερωμένα δεδομένα για κάθε όχημα.
              </p>
              <div className="service-details">
                <div className="detail-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Επίσημη πηγή δεδομένων</span>
                </div>
                <div className="detail-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Ενημερωμένα δεδομένα σε πραγματικό χρόνο</span>
                </div>
                <div className="detail-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Ασφαλής και αξιόπιστη υπηρεσία</span>
                </div>
              </div>
            </div>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 1v4m0 14v4M4.22 4.22l2.83 2.83m9.9 9.9l2.83 2.83M1 12h4m14 0h4M4.22 19.78l2.83-2.83m9.9-9.9l2.83-2.83"/>
              </svg>
              <h4>Ρυθμίσεις Επεξεργασίας</h4>
            </div>
            <p>
              Μετά το ανέβασμα του αρχείου Excel, θα εμφανιστεί η ενότητα 
              <strong> Προχωρημένες Ρυθμίσεις</strong> πάνω από τον πίνακα δεδομένων. 
              Εκεί μπορείτε να προσαρμόσετε την καθυστέρηση μεταξύ των API κλήσεων. 
              Αυτό βοηθάει να αποφύγετε rate limiting και να διασφαλίσετε σταθερή 
              επεξεργασία, ειδικά για μεγάλα αρχεία.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemInfo;

